/** @jsx h */
import { h, Fragment } from 'preact';

export function PromotionCardCodeRedemption({
  discountCode,
  promotionId,
  claimedId,
  redemptionUrl,
  entityId,
  entityName,
  promotionCode,
  showCode,
  showNoCode,
  showGoBtn,
  showCopyGoBtn,
  handleRedeemGo,
  handleRedeemGoAndCopy,
  source,
}) {
  const promotion = {
    promotionId,
    claimedId,
    link: redemptionUrl,
    entityId,
    entityName,
    code: promotionCode,
    promotionCode,
  };

  return (
    <Fragment>
      {showGoBtn && source !== 'confirmation' && (
        <upd-cta primary class="fixed-width">
          <a
            rel="noopener"
            target="_blank"
            href={redemptionUrl}
            onClick={() => {
              handleRedeemGo(promotion);
            }}
          >
            Go
          </a>
        </upd-cta>
      )}
      {source === 'confirmation' && showNoCode && (
        <div class="no-code-container">
          <div class="no-code-instruction">
            Discount automatically applied at checkout.
          </div>
        </div>
      )}
      {showGoBtn && source === 'confirmation' && (
        <upd-cta primary class="fixed-width confirmation">
          <a
            rel="noopener"
            target="_blank"
            href={redemptionUrl}
            onClick={() => {
              handleRedeemGo(promotion);
            }}
          >
            Go
          </a>
        </upd-cta>
      )}
      {showCode && <div class="code" dangerouslySetInnerHTML={discountCode} />}
      {showCopyGoBtn && (
        <upd-cta primary class="claimed">
          <a
            rel="noopener"
            target="_blank"
            href={redemptionUrl}
            onClick={() => {
              handleRedeemGoAndCopy(promotion);
            }}
          >
            Copy & Go
          </a>
        </upd-cta>
      )}
    </Fragment>
  );
}
